export enum UsersTabsEnum {
  users = 'users',
  invites = 'invites',
}
